import React, { useMemo } from 'react';
import DOMPurify from 'dompurify';

/**
 * Renders trusted HTML from the Tiptap editor.
 * We still sanitise defensively before injecting into the DOM.
 */
const HtmlContent = ({ html, className = '' }) => {
  const clean = useMemo(() => {
    if (!html) return '';
    return DOMPurify.sanitize(html, {
      ADD_TAGS: ['iframe'],
      ADD_ATTR: ['allow', 'allowfullscreen', 'frameborder', 'src', 'target', 'rel'],
    });
  }, [html]);

  return (
    <div
      className={`tiptap-body prose prose-slate max-w-none ${className}`}
      data-testid="html-content"
      dangerouslySetInnerHTML={{ __html: clean }}
    />
  );
};

export default HtmlContent;
